export default "__VITE_ASSET__5098f541__"